import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import "./Link.css";
import { useStateValue } from "../../StateProvider";

function Link({option, path}) {
    const [{songToPlay}, dispatch] = useStateValue();
    const location = useLocation();
    const isActive = location.pathname === path;

    const handleClick = (e) => {
        // Close mobile menu when navigating
        dispatch({
            type: "SET_STATEMOBILEMENU",
            isOpen: false,
        });

        // Only reset playBlocker if there's no active song
        if (!songToPlay || songToPlay === "0") {
          dispatch({
            type: "SET_PLAYBLOCKER",
            playBlocker: null,
          });
        }

        // Ensure player button is available when navigating to carousel
        if (path === "/") {
            dispatch({
              type: "SET_SHOWINITIALIZEPLAYERBUTTON",
              showInitializePlayerButton: 1,
            });

            // Reset menustate to carousel when navigating home
            dispatch({
              type: "SET_MENUSTATE",
              menustate: "feedbackcarouselmenu",
            });
        }

        // Reset DB read permission for menu navigation
        dispatch({
          type: "SET_DBLESENCOMINGMENU",
          dblesencomingfrommenu: 1,
        });
    };


    return (
        <div>
            <RouterLink to={path} onClick={handleClick} className={isActive ? 'active' : ''}>
                <button type="button" className={isActive ? 'active' : ''}><h4>{option}</h4></button>
            </RouterLink>
        </div>
    )
}

export default Link
